import cls from 'classnames';
import IconAuto from '@picsart/icons/IconAuto';
import IconLoading from '@picsart/icons/IconLoading';
import IconWarningCircleOutline from '@picsart/icons/IconWarningCircleOutline';
import { useTranslation } from 'react-i18next';
import { memo, useEffect } from 'react';

import { useStore } from '../../store';

import useStyles from './styles';

function GenerateTextButton({ className }: { className: string }) {
  const classes = useStyles();
  const { t } = useTranslation();
  const onClick = useStore((state) => state.generateText);
  const loading = useStore((state) => state.textIsGenerating);
  const setTextIsGenerating = useStore((state) => state.setTextIsGenerating);
  const textGeneratingFailed = useStore((state) => state.textGeneratingFailed);

  useEffect(() => {
    setTextIsGenerating(false);
  }, []);

  return (
    <button disabled={loading} className={cls(classes.root, className)} onClick={onClick}>
      {loading ? (
        <IconLoading className={cls(classes.icon, classes.iconSpinner)} />
      ) : textGeneratingFailed ? (
        <IconWarningCircleOutline className={classes.iconWarn} />
      ) : (
        <IconAuto className={classes.icon} />
      )}
      <span className={classes.inspireElement}> {t('generate.text')} </span>
    </button>
  );
}

export default memo(GenerateTextButton);
